import { render, staticRenderFns } from "./BoCustomerNoteInterne.vue?vue&type=template&id=051b7f6e"
import script from "./BoCustomerNoteInterne.vue?vue&type=script&lang=js"
export * from "./BoCustomerNoteInterne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports